import { createAction } from '@lingoda/core';
import type { AuthStatus } from '../models';

export default createAction<AuthStatus>('auth/SET_STATUS');
